import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { NguCarouselConfig } from '@ngu/carousel';
import { Testimonial } from '@app/models/_index';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss'],
  standalone: false,
})
export class TestimonialsComponent implements OnInit, AfterViewChecked {
  @Input() testimonials: Testimonial[] = [];

  // Custom css overide
  @Input() testimonialBackgroundCSS: string; // Set background color and image
  @Input() testimonialAlignmentCSS: string; // Set text alignment and size
  @Input() testimonialWrapperCSS: string; // Set text wrapping
  @Input() testimonialIcon: string; // Set the icon image if needed
  @Input() arrowColorCSS = 'black'; // Default carousel left and right arrows
  @Input() carouselDotActiveCSS = 'default-active'; // Set background color for carousel dots

  testimonialBanner: NguCarouselConfig;

  constructor(private cdRef: ChangeDetectorRef) {}

  /**
   * OnInit configure the default testimonial configurations to control
   * the carousel responsiveness, speed, intervals, timing.
   * See the NguCarousel open source project on configurations.
   */
  ngOnInit(): void {
    this.testimonialBanner = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 400,
      interval: {
        timing: 20000, // Standard 20 sec between slides
        initialDelay: 1000,
      },
      point: {
        visible: true, // Dots that exist at the bottom of the carousel
      },
      load: 2,
      custom: 'banner',
      loop: true,
      touch: true, // touch is not currently in active for vertical carousel, will enable it in future build
      vertical: {
        enabled: false,
        height: 400,
      },
    };
  }

  /**
   * After view Checks if any changes made to the carousel with the
   * angular change detection reference
   */
  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  /**
   * Add Track By Testimonial Index to not redraw or re-render list items that have not changed.
   * This improves performance.
   * @param index - Index of Testimonial array
   * @param item - Testimonial item
   * @returns Testimonial index
   */
  trackByTestimonialIndex(index: number, item: Testimonial): string {
    // NOTE: Testimonial doesn't have strong key or id and quotes and titles are not unique
    if (item) {
      return item.view;
    } else {
      return String(index);
    }
  }
}
